<template>
  <v-app>
    <v-container>
      <v-row class="pb-3 mb-3" style="border-bottom: 1px solid #ededed">
        <v-col class="col-12">
          <h2 class="mx-2 text-xs-center text-md-left" style="color: var(--v-primary-base)">
            <v-icon size="32" color="primary">date_range</v-icon>Agenda
          </h2>
        </v-col>
      </v-row>
      <v-row class="justify-space-between">
        <v-col class="col-12 col-md-4 col-lg-5">
          <v-date-picker
            v-model="date"
            :events="arrayEvents"
            full-width
            locale="pt-br"
            event-color="secondary"
            color="primary"
          ></v-date-picker>
          <div class="total__schedule px-3 py-2">
            <p>
              Total de atendimentos agendados para o dia {{ date | formatDate }} :
              <span>{{ total }}</span>
            </p>
          </div>
          <div class="total__time px-3 py-2">
            <p>
              Total de horários disponíveis para o dia {{ date | formatDate }} :
              <span>{{ total_time_slots }}</span>
            </p>
          </div>
          <div class="py-4 pa-md-3" style="display: flex; justify-content: space-around">
            <v-btn :disabled="total_time_slots == 0" color="gray" large dark to="edit-schedule"
              >EDITAR AGENDA</v-btn
            >
            <v-btn color="secondary" large @click="goToCreateSchedule">CRIAR AGENDA</v-btn>
            <v-dialog v-model="dialog" max-width="390">
              <v-card>
                <v-card-title class="headline">Atenção</v-card-title>
                <v-card-text>
                  {{ dialogTitle }}
                  <p class="font-weight-bold">{{ dialogSubTitle }}</p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="secondary darken-1"
                    text
                    @click="dialog = false"
                    :to="{ name: this.confirmErrorGoTo }"
                    >OK</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-col>
        <v-col class="col-12 col-md-8 col-lg-7">
          <div class="d-flex justify-center align-center flex-column" v-if="isLoading">
            <p>Carregando...</p>
            <v-progress-circular indeterminate color="primary" class="mb-0"></v-progress-circular>
          </div>
          <v-row class="mt-0" v-else>
            <v-col class="col-12 col-md-6 py-0" v-if="consultation">
              <div class="lightGray px-3 py-2">
                <h3 class="font-weight-regular" style="color: var(--v-primary-base)">
                  Consultas como psicólogo:
                </h3>
              </div>
              <v-divider></v-divider>
              <router-link
                v-for="item in consultation"
                :key="item.id"
                tag="div"
                style="cursor: pointer"
                class="my-list"
                :to="{ name: 'DetalheConsulta', params: { id: item.id } }"
              >
                <p class="ma-0">{{ item.patient.name }}</p>
                <span class="date ma-2 align-end d-flex">
                  <v-icon color="primary">date_range</v-icon>
                  <p class="mb-0 ml-2">{{ date | formatDate }}</p>
                </span>
                <span class="time ma-2 align-end d-flex">
                  <v-icon color="primary">access_time</v-icon>
                  <p class="mb-0 ml-2">
                    {{ item.time | formatDateTZ(item.date, item.time) }}
                  </p>
                </span>
              </router-link>
            </v-col>
            <v-col class="col-12 col-md-6 py-0" v-if="psi.is_chief_therapist">
              <div class="lightGray px-3 py-2">
                <h3 class="font-weight-regular" style="color: var(--v-primary-base)">
                  Consultas de terapeuta:
                </h3>
              </div>
              <v-divider></v-divider>
              <div
                class="my-list"
                style="cursor: pointer"
                v-for="item in therapistConsultation"
                :key="item.id"
                @click="goToDetalheConsulta(item)"
              >
                <p class="ma-0" v-if="item.patient != null">
                  {{ item.patient.name }}
                </p>
                <p class="ma-0" v-if="item.patient_psychologist != null">
                  {{ item.patient_psychologist.name }}
                </p>
                <span class="date ma-2 align-end d-flex">
                  <v-icon color="primary">date_range</v-icon>
                  <p class="mb-0 ml-2">{{ date | formatDate }}</p>
                </span>
                <span class="time ma-2 align-end d-flex">
                  <v-icon color="primary">access_time</v-icon>
                  <p class="mb-0 ml-2">
                    {{ item.time | formatDateTZ(item.date, item.time) }}
                  </p>
                </span>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { getProfile } from '../../services/psychologists';
import Api from '../../services/httpClient';

export default {
  data() {
    return {
      isLoading: false,
      date: new Date().toISOString().substr(0, 10),
      arrayEvents: [],
      cod: '',
      consultation: [],
      therapistConsultation: [],
      total: '0',
      total_time_slots: '0',
      psi: {},
      dialog: false,
      dialogTitle: '',
      dialogSubTitle: '',
      confirmErrorGoTo: '',
    };
  },
  async created() {
    await this.getCod();
    await this.allConsultation();
    await this.getConsultation();
    this.totalTimeSlots();
    this.isLoading = false;
  },
  watch: {
    date(val) {
      this.getConsultation();
      this.totalTimeSlots();
    },
  },
  methods: {
    goToDetalheConsulta(consulta) {
      // Se não tiver paciente é porque é uma consulta de psicólogo com terapeuta
      if (consulta.patient == null) {
        this.$router.push({
          name: 'ConsultaTerapeuta',
          params: { id: consulta.id },
        });
      } else {
        // Se tiver paciente é porque é uma consulta normal (paciente com psicólogo)
        this.$router.push({
          name: 'DetalheConsulta',
          params: { id: consulta.id },
        });
      }
    },
    async getCod() {
      this.cod = localStorage.getItem('user-id');
      const res = await getProfile(this.cod);
      this.psi = res;
      console.log('psi ', res);
    },
    goToCreateSchedule() {
      if (!this.psi.is_active) {
        this.dialog = true;
        this.dialogTitle = 'Você precisa estar aprovado para poder criar agenda como psicólogo';
        this.dialogSubTitle =
          'Entre em contato por email: suporte@ondivan.com para saber o status da sua solicitação.';
        this.confirmErrorGoTo = 'DashboardPsicologo';
        return;
      }

      // if (!this.psi.digital_account) {
      //   this.dialog = true;
      //   this.dialogTitle = 'Registe sua conta digital!';
      //   this.dialogSubTitle = 'Para disponibilizar os seus horários de atendimento na plataforma é necessário registar uma conta digital. Será através dela que irá receber os seus pagamentos.';
      //   this.confirmErrorGoTo = 'CadastroBancario';
      //   return;
      // }

      this.$router.push('/psicologo/create-schedule');
    },
    async getConsultation() {
      this.isLoading = true;
      Api.get(`/psychologists/${this.cod}/appointments/`, {
        params: {
          date: this.date,
          with_chief_therapist: true,
        },
        headers: {
          Authorization: `Token ${localStorage.getItem('user-token')}`,
        },
      })
        .then((response) => {
          this.therapistConsultation = [];
          this.consultation = [];
          if (this.psi.is_chief_therapist) {
            // eslint-disable-next-line no-restricted-syntax
            for (const appointment of response.data) {
              if (appointment.with_chief_therapist) {
                this.therapistConsultation.push(appointment);
              } else {
                this.consultation.push(appointment);
              }
            }
          } else {
            this.consultation = response.data;
          }
          this.total = response.data.length;
        })
        .catch((err) => {
          this.$showSnackbar('Erro ao realizar o agendamento. Tente Novamente.');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    totalTimeSlots() {
      Api.get(`/psychologists/${this.cod}/time_slots/`, {
        params: {
          date: this.date,
        },
        headers: {
          Authorization: `Token ${localStorage.getItem('user-token')}`,
        },
      })
        .then((response) => {
          this.total_time_slots = response.data.length;
        })
        .catch((erro) => {
          console.log(erro);
        });
    },
    allConsultation() {
      Api.get(`/psychologists/${this.cod}/appointments/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem('user-token')}`,
        },
      }).then((response) => {
        // eslint-disable-next-line no-restricted-syntax
        for (const item of response.data.results) {
          this.arrayEvents.push(item.date);
        }
      });
    },
    // totalConsultations: async function() {
    //   try {
    //     const result =  await Api.get(`/psychologists/${this.cod}/appointments/`,
    //     {
    //       headers: {
    //         Authorization: `Token ${localStorage.getItem("user-token")}`
    //       }
    //     });
    //     this.total = result.data.count;
    //     // console.log(result.data.count);
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
  },
};
</script>
<style scoped>
* >>> .dayContainer {
  width: 450px;
  max-width: 450px;
}
.my-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 0;
}
.my-list p {
  flex: 1;
}
.total__schedule {
  background-color: #e3ffe3;
}
.total__time {
  background-color: #fffde3;
}
.total__schedule p,
.total__time p {
  color: #6f6f6f;
  margin: 0;
  position: relative;
}
.total__schedule p span,
.total__time p span {
  color: #02a554;
  font-weight: bold;
  position: absolute;
  right: 5px;
}
@media screen and (max-width: 320px) {
  .v-card__actions .v-btn.v-btn {
    width: 110px !important;
  }
}
</style>
